// extracted by mini-css-extract-plugin
export default {"betaSign":"styles_betaSign__XGy8W","beta-sign-icon-container":"styles_beta-sign-icon-container__V7EJy"};